import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  title: {
    marginTop: spacing(4),
    marginBottom: spacing(3),
  },
  btnGroup: {
    display: 'grid',
    marginTop: spacing(6),
    gridTemplateColumns: 'auto auto',
    gridGap: spacing(3),
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: '100%',
  },
});

export default styles;
